/* eslint-disable max-len */
import { BaseSignalRModel } from '../BaseSignalRModel';
import { AppRequestInfo } from '@/entities/AppRequestInfo';
import { SignalRModelRequest } from '../SignalRModelRequest';
import SubModuleEnum from '@/enums/SubModuleEnum';
import ModuleEnum from '@/enums/ModuleEnum';
import { CustomCategoryFolder, CustomCategoryFolderItemSignalR } from '@/entities/CustomCategory/CustomCategoryFolder';
import NotificationStatusEnum from '@/enums/NotificationStatusEnum';
import { app } from '@/main';

const FolderSignalRModelRequestIds = {
  SingleCreate: 1,
  SingleEdit: 2,
  SingleDelete: 3,
};

export class FolderSignalRModel extends BaseSignalRModel {
  // Get SignalRModelRequest for adding a single folder item
  get SingleCreateFolderItemSignalRModelRequest(): SignalRModelRequest {
    return this.GetSelectedSignalRModelRequestByID(FolderSignalRModelRequestIds.SingleCreate);
  }
  // Get SignalRModelRequest for Updating a single folder item
  get SingleUpdateFolderItemSignalRModelRequest(): SignalRModelRequest {
    return this.GetSelectedSignalRModelRequestByID(FolderSignalRModelRequestIds.SingleEdit);
  }
  // Get SignalRModelRequest for Deleting a single folder item
  get SingleDeleteFolderItemSignalRModelRequest(): SignalRModelRequest {
    return this.GetSelectedSignalRModelRequestByID(FolderSignalRModelRequestIds.SingleDelete);
  }
  readonly customCategoryBatchOperationURL = '/BulkOperations/PerformBatchOperation';
  readonly customCategoryPostToClientsSignalRURL = '/BulkOperations/PostToClientsSignalR';
  constructor(public rootObj: any, public $store: any, public $t: any) {
    super(rootObj, $store);
    const reqInfo: AppRequestInfo = this.GetRequestInfoFromStore();
    const loggedInUserFullName = reqInfo.FirstName + ' ' + reqInfo.LastName;
    const signalRAPICustomCategoryURL = app.config.globalProperties.$SignalRBaseURL + 'api/SignalRInformation/PushCustomCategorySignalRChanges';

    this.arrSignalRModelRequests.push(new SignalRModelRequest(FolderSignalRModelRequestIds.SingleCreate, ModuleEnum.InformationFolder, SubModuleEnum.SingleCreate, reqInfo.ApplicationId, reqInfo.ApplicationInstanceId, BaseSignalRModel.newGuid(), reqInfo.Username, loggedInUserFullName, reqInfo.AdminType, signalRAPICustomCategoryURL, [], 'Notifications.SaveOperation', '', 'Notifications.SavingFolderItem', 'Notifications.SavedFolderItem', false, null,'', false, new Date(), '', NotificationStatusEnum.Sending, '', 'ActionUpdatingSingleFolder'));

    this.arrSignalRModelRequests.push(new SignalRModelRequest(FolderSignalRModelRequestIds.SingleEdit, ModuleEnum.InformationFolder, SubModuleEnum.SingleEdit,  reqInfo.ApplicationId, reqInfo.ApplicationInstanceId, BaseSignalRModel.newGuid(), reqInfo.Username, loggedInUserFullName, reqInfo.AdminType, signalRAPICustomCategoryURL, [], 'Notifications.UpdateOperation', '', 'Notifications.UpdatingFolderItem', 'Notifications.UpdatedFolderItem', false, null,'', false, new Date(), '', NotificationStatusEnum.Sending, '', 'ActionUpdatingSingleFolder'));

    this.arrSignalRModelRequests.push(new SignalRModelRequest(FolderSignalRModelRequestIds.SingleDelete, ModuleEnum.InformationFolder, SubModuleEnum.SingleDelete,  reqInfo.ApplicationId, reqInfo.ApplicationInstanceId, BaseSignalRModel.newGuid(), reqInfo.Username, loggedInUserFullName, reqInfo.AdminType, signalRAPICustomCategoryURL, [], 'Notifications.DeleteOperation', '', 'Notifications.DeleteSingleFolderItem', 'Notifications.DeletedSingleFolderItem', false, null,'', false, new Date(), '', NotificationStatusEnum.Sending, '', 'ActionUpdatingSingleFolder'));
  }
  // Add to Notification Popup that an operation has started
  public AddToNotificationPopup(signalRModelRequest: SignalRModelRequest) {
    this.EmitAddNewNotifications(signalRModelRequest);
  }
  // Get Folder Item send to SignalR as JSON data
  public GetFolderItemSendToSignalR(customCategoryFolder: CustomCategoryFolder): string {
    const item: CustomCategoryFolderItemSignalR =
            CustomCategoryFolderItemSignalR.GetCustomCategoryFoldersItemSignalR(customCategoryFolder);
    return JSON.stringify(item);
  }
  // Perform Folder Single Operations
  public PerformFolderSingleOperation(signalRModelRequest: SignalRModelRequest) {

    this.SendSignalRModelRequestToHubWithoutAddingToQueue(signalRModelRequest, this.customCategoryPostToClientsSignalRURL);
    this.SendSignalRModelRequestToQueueWithoutEmit(signalRModelRequest, this.customCategoryBatchOperationURL);
  }
  // Method that fires when Folder SignalR response model is received from Hub
  public FolderSignalRModelResponseReceived(signalRModelRequest: SignalRModelRequest) {
    this.SignalRModelResponseReceived(signalRModelRequest);
  }
}
